module.exports = __webpack_public_path__ + "img/repeat.bb0134a1.svg";